import * as React from 'react';
import { styled } from '@linaria/react';

import FakeBrowserWindow from '@/components/FakeBrowserWindow';
import Space from '@/components/Space';

const SMOOTH_GRADIENT = `linear-gradient(
    to bottom,
    hsl(210deg 15% 6% / 1) 0%,
    hsl(210deg 15% 6% / 0) 50%
  )`;

function LeavingTheTop({ withGradient }: { withGradient?: boolean }) {
  return (
    <Browser maxHeight="250px">
      <Wrapper>
        <Header>
          <GlassyBackdrop
            style={{
              background: withGradient
                ? SMOOTH_GRADIENT
                : 'hsl(210deg 15% 6% / 0.1)',
            }}
          />
        </Header>

        <BoatImg
          loading="lazy"
          src="/images/backdrop-filter/boats.jpg"
        />
      </Wrapper>
    </Browser>
  );
}

const Browser = styled(FakeBrowserWindow)`
  margin-inline: -1rem;
  margin-top: 1rem;
  margin-bottom: 4rem;
`;

const Wrapper = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  border-radius: 0;
  isolation: isolate;
  border-right: 1px solid var(--color-content-outline);
  height: 600px;
`;

const Header = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  width: 100%;
  z-index: 2;
  border-bottom: 1px solid hsl(210deg 20% 70% / 0.2);
  overflow: hidden;
`;

const GlassyBackdrop = styled.div`
  position: absolute;
  inset: 0;
  backdrop-filter: blur(8px);
  pointer-events: none;
  height: 200%;
`;

const BoatImg = styled.img`
  width: 100%;
  max-width: 300px;
  margin-top: 1rem;
`;

export default LeavingTheTop;
